// pages/posts/[slug].js
import ErrorPage from "next/error";
import { useRouter } from "next/router";
import { groq } from "next-sanity";
import { usePreviewSubscription, urlFor } from "../../lib/sanity";
import { getClient } from "../../lib/sanity.server";
import Post from "../../view/screens/Blog/Post";

const postQuery = groq`
  *[_type == "post" && slug.current == $slug][0] {
    _id,
    title,
    publishedAt,
    body,
    mainImage,
    author ->{
      name,
      image,
      title,
      slug
    },
    categories[]->{
      _id,
      title,
      slug
    },
    "slug": slug.current
  }
`;

export default function PostPage({ data, preview }) {
    const router = useRouter();

    const { data: post } = usePreviewSubscription(postQuery, {
        params: { slug: data.post?.slug },
        initialData: data.post,
        enabled: preview && data.post?.slug,
    });

    if (!router.isFallback && !data.post?.slug) {
        return <ErrorPage statusCode={404} />;
    }

    const { title, publishedAt, mainImage, body } = post;

    return <Post preview={preview} post={post}></Post>;
}

export async function getStaticProps({ params, preview = false }) {
    const post = await getClient(preview).fetch(postQuery, {
        slug: params.slug,
    });

    return {
        props: {
            preview,
            data: { post },
        },
        revalidate: 10,
    };
}

export async function getStaticPaths() {
    const paths = await getClient().fetch(
        groq`*[_type == "post" && defined(slug.current)][].slug.current`
    );

    return {
        paths: paths.map((slug) => ({ params: { slug } })),
        fallback: "blocking",
    };
}
